import {
  ABOVE_THE_HEADER,
  CHANGE_DIRECTION,
  CHANGE_NAVIGATION_STYLE,
  DARK_THEME,
  DRAWER_TYPE,
  FIXED_DRAWER,
  HORIZONTAL_MENU_POSITION,
  SWITCH_LANGUAGE,
  THEME_COLOR,
  TOGGLE_COLLAPSED_NAV,
  VERTICAL_NAVIGATION,
  WINDOW_WIDTH,
  INSIDE_THE_HEADER,
  // SHOW_MESSAGE_ON,
  // SHOW_MESSAGE_OFF,
  // ERROR_MESSAGE_OFF,
  // ERROR_MESSAGE_ON,
  // SETTING_HANDLE_REQUEST_CLOSE,
} from "../constants/ActionTypes";
import { INDIGO } from "../constants/ThemeColors";

const rltLocale = ["ar"];
const initialSettings = {
  navCollapsed: false,
  drawerType: FIXED_DRAWER,
  themeColor: INDIGO,
  darkTheme: false,
  width: window.innerWidth,
  isDirectionRTL: false,
  navigationStyle: VERTICAL_NAVIGATION,
  horizontalNavPosition: INSIDE_THE_HEADER,
  locale: {
    languageId: "english",
    locale: "en",
    name: "English",
    icon: "us",
  },
  showMessage: false,
  errorMessage: false,
  alertMessage: "",
};

const settings = (state = initialSettings, action) => {
  switch (action.type) {
    case "@@router/LOCATION_CHANGE":
      return {
        ...state,
        navCollapsed: false,
      };
    case TOGGLE_COLLAPSED_NAV:
      return {
        ...state,
        navCollapsed: action.isNavCollapsed,
      };
    case DRAWER_TYPE:
      return {
        ...state,
        drawerType: action.drawerType,
      };
    case WINDOW_WIDTH:
      return {
        ...state,
        width: action.width,
      };
    case THEME_COLOR:
      return {
        ...state,
        darkTheme: false,
        themeColor: action.color,
      };
    case DARK_THEME:
      return {
        ...state,
        darkTheme: !state.darkTheme,
      };
    case SWITCH_LANGUAGE:
      return {
        ...state,
        locale: action.payload,
        isDirectionRTL: rltLocale.includes(action.payload.locale),
      };
    case CHANGE_DIRECTION:
      return {
        ...state,
        isDirectionRTL: !state.isDirectionRTL,
      };
    case CHANGE_NAVIGATION_STYLE:
      return {
        ...state,
        navigationStyle: action.payload,
      };
    case HORIZONTAL_MENU_POSITION:
      return {
        ...state,
        horizontalNavPosition: action.payload,
      };
    // case SHOW_MESSAGE_ON:
    //   return { ...state, showMessage: true, alertMessage: payload };
    // case SHOW_MESSAGE_OFF:
    //   return { ...state, showMessage: false, alertMessage: "" };
    // case ERROR_MESSAGE_ON:
    //   return { ...state, errorMessage: true, alertMessage: payload };
    // case ERROR_MESSAGE_OFF:
    //   return { ...state, errorMessage: false, alertMessage: "" };
    // case SETTING_HANDLE_REQUEST_CLOSE:
    //   return { ...state, showMessage: false, errorMessage: false, alertMessage: "" };

    default:
      return state;
  }
};

export default settings;



// WEBPACK FOOTER //
// ./reducers/Settings.js